import { LayoutNameResolver } from "./LayoutNameResolver";
import { StringUtil } from "./StringUtil";
import { UrlUtil } from "./UrlUtil";
import { ValueOrFunction } from "./ValueOrFunctionTypes";
import { ValueResolver } from "./ValueResolver";

  export class LayoutUrl {

    /**
     * Creates a relative layout URL with optional query params.
     * - Resolves and checks permissions on the layoutPath
     * - Returns null if the layout is denied/invalid or any param value is null/undefined.
     *
     * @param layoutPath Layout path or resolver (e.g., "lme/dispatch/OrderTabView").
     * @param params Optional query parameters (e.g., { mode: "update", key: "123", orderId: "ABC" })
     * @returns Relative URL (e.g., "lme/dispatch/OrderTabView?mode=update&key=123&orderId=ABC") or null.
     */
    public static create(
        layoutPath: ValueOrFunction<string>,
        params?: Record<string, any>
    ): string | null {

      const resolvedPath = LayoutNameResolver.resolve(layoutPath);
      if (StringUtil.isEmptyString(resolvedPath))
        return null;

      if (params == null)
        return resolvedPath;

      if (Object.values(params).some(v => v == null))
        return null;

      return `${resolvedPath}${UrlUtil.buildQueryString(params)}`;
    }


    /**
     * Creates layout URL for update mode.
     * Equivalent to create(layoutPath, { mode: "update", key: keyValue }).
     * - Resolves and checks permissions on the layoutPath
     * - Returns null if the layout is denied/invalid or any param value is null/undefined.
     *
     * @param layoutPath Layout path or resolver.
     * @param keyValue key value to include in the query param
     * @returns Relative URL (e.g., "lme/dispatch/Movement?mode=update&key=123") or null.
     */
    public static createForUpdateMode(layoutPath: ValueOrFunction<string>, keyValue: ValueOrFunction<string>): string | null {
        const resolvedKeyValue = ValueResolver.resolve(keyValue);
        if (StringUtil.isEmptyString(resolvedKeyValue))
            return null;
        return this.create( layoutPath, {  mode: "update", key: resolvedKeyValue } );
    }
  }
